import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "share-result-card-container d-flex justify-content-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("b", null, "Salvar e compartilhar resultado", -1)
const _hoisted_4 = { class: "icons-container d-flex justify-content-between align-items-center" }
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    id: 
      _ctx.theme === 'chembio' ? 'share-result-button-hiv' : 'share-result-button'
    
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "share-result-card d-flex justify-content-between",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('open-result-card')))
      }, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", { src: _ctx.whatsappIconPath }, null, 8, _hoisted_5),
          _createElementVNode("img", { src: _ctx.instagramIconPath }, null, 8, _hoisted_6),
          _createElementVNode("img", { src: _ctx.emailIconPath }, null, 8, _hoisted_7)
        ])
      ])
    ])
  ], 8, _hoisted_1))
}